// Returns `(key, value) => value`: for each key, the previously returned value
// while the content (JSON) of the new one is the same. The content is
// compared as it was when the value was first returned, so later changes made
// to that object by its users don't matter.
export function createContentCache() {
  const cache = new Map();

  return (key, value) => {
    const json = JSON.stringify(value);
    const cached = cache.get(key);
    if (cached?.json === json) return cached.value;

    cache.set(key, { json, value });
    return value;
  };
}
